import FastMarquee from "react-fast-marquee";

const phrases = [
  "Neat, no ice.",
  "Cask strength.",
  "One dram at a time.",
  "By order of the palate.",
  "Peat & consequence.",
  "The gentleman waits.",
  "Sláinte.",
  "Two fingers, one truth.",
];

export default function Marquee() {
  return (
    <section
      data-testid="marquee-section"
      aria-label="Editorial marquee"
      className="overflow-clip-x border-y py-8 md:py-10"
      style={{ borderColor: "var(--hairline)", background: "var(--surface)" }}
    >
      <FastMarquee speed={28} gradient={false} pauseOnHover>
        {phrases.map((p, i) => (
          <span key={i} className="marquee-item font-display italic text-4xl md:text-6xl text-bone/90">
            {p}
            <span className="marquee-dot" />
          </span>
        ))}
      </FastMarquee>
    </section>
  );
}
